export default "__VITE_ASSET__bd680148__"